export const experienceData = [
  {
    id: 1,
    company: "Mobiloitte Technologies India Pvt. Ltd. New Delhi",
    jobtitle: "Frontend Developer Engineer",
    startYear: "9th Mar 2022",
    endYear: "1st Aug 2022",
  },
  {
    id: 2,
    company: "Agnito Technologies Pvt. Ltd. Bhopal",
    jobtitle: "Frontend Developer Tranee",
    startYear: "13th Dec 2021",
    endYear: "7th Mar 2022",
  },
  {
    id: 3,
    company: "Techwon Labs Pvt. Ltd. Jamshedpur, Jharkhand",
    jobtitle: "Web Developer Intern",
    startYear: "07th June 2021",
    endYear: "21st July 2021",
  },
  {
    id: 4,
    company: "Pantech ProLabs India Pvt. Ltd. Chennai, Tamil Nadu",
    jobtitle: "Machine learning Intern",
    startYear: "1st May 2021",
    endYear: "30th May 2021",
  },
];
